export default __webpack_public_path__ + "static/media/JuDu.307bd680.mp4";